import withStore, { TLoadingAwarePresenter, TPresentable } from "../withStore";
import Application from "../../Application";
import LoginInteractor from "../../interactor/authentication/LoginInteractor";
import ShowErrorMessageInteractor from "../../interactor/notifications/ShowErrorMessageInteractor";
import { Errors } from "../../common/Constants";

export interface TLoginPresenter extends TLoadingAwarePresenter {
  username: string;
  password: string;
  loginButtonDisabled: boolean;
  redirectRoute?: string;
}
export interface ILoginPresenter extends TLoginPresenter, TPresentable {
  login(): void;
  setUsername(username: string): void;
  setPassword(password: string): void;
}

const defaultState: TLoginPresenter = {
  username: "",
  password: "",
  loginButtonDisabled: true
};

const LoginPresenter = withStore<ILoginPresenter, TLoginPresenter>(
  ({ application, store, loader, translate }): ILoginPresenter => {
    const _store = store;
    const _application: Application = application;
    const state = _store.getState<TLoginPresenter>();

    const setUsername = (username: string) => {
      _store.update({
        username
      });
      setLoginButtonDisabled();
    };

    const setPassword = (password: string) => {
      _store.update({
        password
      });
      setLoginButtonDisabled();
    };

    const setLoginButtonDisabled = () => {
      const { username, password } = _store.getState<TLoginPresenter>();
      if (username && password) {
        return _store.update({ loginButtonDisabled: false });
      }
      return _store.update({ loginButtonDisabled: true });
    };

    const login = async () => {
      loader.start("loginLoader");
      const { username, password, redirectRoute } =
        _store.getState<TLoginPresenter>();
      let error = await _application.container
        .resolve<LoginInteractor>("login")
        .execute(username, password, undefined, redirectRoute);

      if (error && error.code === Errors.LOGIN_ERROR) {
        loader.stop("loginLoader");
        _application.container
          .resolve<ShowErrorMessageInteractor>("showErrorMessage")
          .execute((error as any).message);
      }

      loader.stop("loginLoader");
    };

    return {
      ...state,
      store: _store,
      loader,
      application: _application,
      translate,
      login,
      setPassword,
      setUsername
    };
  },
  defaultState
);

export default LoginPresenter;
